import { LOCALE_ID, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

//Main Components
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { ReportsComponent } from './reports/reports.component';
import { AdministrationComponent } from './administration/administration.component';
import { SettingsComponent } from './settings/settings.component';

//Layout Components
import { BodyComponent } from './layout/body/body.component';
import { SidenavComponent } from './layout/sidenav/sidenav.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';

//WebView
import { BannerManageServiceComponent } from './WebView/Banners/banner-manage-service/banner-manage-service.component';
import { BannerSuccessBookingComponent } from './WebView/Banners/banner-success-booking/banner-success-booking.component';
import { ScheduleAppointmentComponent } from './WebView/FormWebView/diary/schedule-appointment/schedule-appointment.component';
import { MyReservationComponent } from './WebView/FormWebView/my-reservation/my-reservation.component';
import { ChooseServiceComponent } from './WebView/FormWebView/diary/choose-service/choose-service.component';
import { ChooseServiceWorkshopComponent } from './WebView/FormWebView/diary/choose-service-workshop/choose-service-workshop.component';

import { ConsultantFormComponent } from './WebView/FormWebView/query/consultant-form/consultant-form.component';

//Dashboard Sub Modules
import { OverallSummaryComponent } from './dashboard/overall-summary/overall-summary.component';
import { CalendarComponent } from './dashboard/calendar/calendar.component';

//Management / Administration Sub Modules
import { TemplatesComponent } from './administration/templates/templates.component';

import { WorkshopsComponent } from './administration/workshops/workshops.component';
import { AdvisorsComponent } from './administration/advisors/advisors.component';
import { CustomerBaseComponent } from './administration/Components/customer-base/customer-base.component';

//Dialogs
import { AddTemplateDialog } from './administration/templates/dialogs/add-template/add-template.dialog';
import { DeleteTemplateDialog } from './administration/templates/dialogs/delete-template/delete-template.dialog';
import { EditInfoDialog } from './administration/workshops/dialogs/edit-info/edit-info.dialog';
import { ConfigureHoursDialog } from './administration/workshops/dialogs/configure-hours/configure-hours.dialog';
import { LockSettingsDialog } from './administration/workshops/dialogs/lock-settings/lock-settings.dialog';
import { DeleteWorkshopDialog } from './administration/workshops/dialogs/delete-workshop/delete-workshop.dialog';
import { CustomDatePickerHeader } from './administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-picker-header';
import { CancelAppointmentDialog } from './scheduling/dialogs/cancel-appointment/cancel-appointment.dialog';

import { EditInfoDialogadvisor } from './administration/advisors/dialogs/edit-info/edit-info-advisor.dialog';
import { DeleteadvisorDialog } from './administration/advisors/dialogs/delete-advisor/delete-advisor.dialog';
import { LockSettingsDialogAdvisor } from './administration/advisors/dialogs/lock-settings/lock-settings-advisor.dialog';
import { ConfigureHoursDialogAdvisors } from './administration/advisors/dialogs/configure-hours/configure-hours-advisor.dialog';
import { deleteLockSettingsDialog } from './administration/workshops/dialogs/lock-settings/delete-lock-settings/delete-lock-settings.dialog';
import { deleteLockSettingsAdvisorDialog } from './administration/advisors/dialogs/lock-settings/delete-lock-settings-advisor/delete-lock-settings-advisor.dialog';
//Angular Material Imports

//Other Imports
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { CancelAppointmentComponent } from './WebView/FormWebView/query/consultant-form/cancel-appointment/cancel-appointment.component';
import { InformationModalComponent } from './WebView/FormWebView/query/consultant-form/information-modal/information-modal.component';
import { CalendarwebComponent } from './WebView/FormWebView/diary/choose-service-workshop/calendar-web/calendarweb.component';

import { RescheduleAppointmentDialog } from './scheduling/dialogs/reschedule-appointment/reschedule-appointment.dialog';
import { SearchPlateDialog } from './scheduling/dialogs/search-plate/search-plate.dialog';
import { SchedulingPlateFoundEditDialog } from './scheduling/dialogs/plate-found-edit/scheduling-plate-found-edit.dialog';
import { LoginComponent } from './WebView/login/login.component';
import { CalendarWebHourComponent } from './WebView/FormWebView/diary/choose-service/calendar-web-hour/calendar-web-hour.component';

//ngx translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { IDashboardComponent } from './incadea/i-dashboard/i-dashboard.component';
import { ISchedulingComponent } from './incadea/i-scheduling/i-scheduling.component';

import { FilterWorkshopsPipe } from './pipes/filterWorkshops.pipe';

import { CarouselComponent } from './administration/Components/carousel/carousel.component';
import { MaterialModule } from './modules/material.module';
import { LegacyDateAdapter } from './modules/legacy-date-adapter';

import { IBannerManageServiceComponent } from './incadea/i-web-view/i-banners/i-banner-manage-service/i-banner-manage-service.component';
import { IBannerSuccessBookingComponent } from './incadea/i-web-view/i-banners/i-banner-success-booking/i-banner-success-booking.component';
import { IConsultantAppointmentComponent } from './incadea/i-web-view/i-consultant-appointment/i-consultant-appointment.component';
import { ICancelAppointmentComponent } from './incadea/i-web-view/i-consultant-appointment/i-cancel-appointment/i-cancel-appointment.component';
import { IScheduleChooseComponent } from './incadea/i-web-view/i-schedule-choose/i-schedule-choose.component';
import { ICreateAppointmentComponent } from './incadea/i-web-view/i-create-appointment/i-create-appointment.component';
import { IMyReservationComponent } from './incadea/i-web-view/i-create-appointment/i-component-create-appoiment/i-my-reservation/i-my-reservation.component';
import { ICalendarWebComponent } from './incadea/i-web-view/i-create-appointment/i-component-create-appoiment/i-calendar-web/i-calendar-web.component';
import { FindClientInfoDialog } from './incadea/i-scheduling/I-dialogs/findClientInfo/find-client-info.dialog';
import { RescheduleDialog } from './incadea/i-scheduling/I-dialogs/reschedule/reschedule.dialog';
import { AppointmentComponent } from './incadea/i-scheduling/I-dialogs/newAppointment/appointment.component';
import { ICancelAppointmentDialog } from './incadea/i-scheduling/I-dialogs/cancelAppointment/i-cancel-appointment.dialog';
import { IReportsComponent } from './incadea/i-reports/i-reports.component';
import { ICalendarComponent } from './incadea/i-dashboard/i-calendar/i-calendar.component';
import { DatePipe } from '@angular/common';
import { IOverallSummaryComponent } from './incadea/i-dashboard/i-overall-summary/i-overall-summary.component';
import { FilterAdvisorsPipe } from './pipes/filterAdvisors.pipe';
import { ActiveServicesPipe } from './pipes/active-services.pipe';
import { UsersComponent } from './users/users.component';
import { ChangeStateUserDialog } from './users/Dialogs/change-state-user/change-state-user.dialog';
import { FilterUserManagement } from './pipes/filterUserManagement.pipe';
import { EditInfoUserDialog } from './users/Dialogs/edit-user/edit-info-user.dialog';
import { CreateUserDialog } from './users/Dialogs/create-user/create-user.dialog';
import { DeleteUserDialog } from './users/Dialogs/delete-user/delete-user.dialog';
import { ClientsComponent } from './administration/clients/clients.component';
import { filterClientManagement } from './pipes/filterClientManagement.pipe';
import { EditionClientsComponent } from './administration/clients/Dialogs/edition-clients/edition-clients.component';
import { CreationClientsComponent } from './administration/clients/Dialogs/creation-clients/creation-clients.component';
import { DeleteClientDialog } from './administration/clients/Dialogs/delete-clients/delete-clients.dialog';

import { FullCalendarModule } from '@fullcalendar/angular';
import { PopoverReschedulingComponent } from './scheduling/dialogs/popover-rescheduling/popover-rescheduling.component';
//Bootstrap
import { AlertComponent } from './layout/alert/alert.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { IPopoverReschedulingComponent } from './incadea/i-scheduling/I-dialogs/i-popover-rescheduling/i-popover-rescheduling.component';
import { NotFoundComponent } from './layout/not-found/not-found.component';
import { sessionFailedComponent } from './WebView/login/Components/sessionFailed/sessionFailed.component';

import { MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule as MatInputModule } from '@angular/material/input';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        BodyComponent,
        SidenavComponent,
        DashboardComponent,
        AdministrationComponent,
        ReportsComponent,
        SchedulingComponent,
        SettingsComponent,
        HeaderComponent,
        FooterComponent,
        TemplatesComponent,
        WorkshopsComponent,
        OverallSummaryComponent,
        CalendarComponent,
        AdvisorsComponent,
        AddTemplateDialog,
        DeleteTemplateDialog,
        EditInfoDialog,
        ConfigureHoursDialog,
        LockSettingsDialog,
        DeleteWorkshopDialog,
        CustomDatePickerHeader,
        CancelAppointmentDialog,
        RescheduleAppointmentDialog,
        SearchPlateDialog,
        deleteLockSettingsAdvisorDialog,
        SchedulingPlateFoundEditDialog,
        deleteLockSettingsDialog,
        FindClientInfoDialog,
        CustomerBaseComponent,
        EditInfoDialogadvisor,
        DeleteadvisorDialog,
        LockSettingsDialogAdvisor,
        ConfigureHoursDialogAdvisors,
        BannerManageServiceComponent,
        BannerSuccessBookingComponent,
        ScheduleAppointmentComponent,
        MyReservationComponent,
        ChooseServiceComponent,
        ChooseServiceWorkshopComponent,
        ConsultantFormComponent,
        CancelAppointmentComponent,
        CalendarwebComponent,
        ConfigureHoursDialogAdvisors,
        LoginComponent,
        sessionFailedComponent,
        CalendarWebHourComponent,
        IDashboardComponent,
        ISchedulingComponent,
        IBannerManageServiceComponent,
        CarouselComponent,
        AppointmentComponent,
        IBannerManageServiceComponent,
        IBannerSuccessBookingComponent,
        IConsultantAppointmentComponent,
        ICancelAppointmentComponent,
        IScheduleChooseComponent,
        ICreateAppointmentComponent,
        IMyReservationComponent,
        ICalendarWebComponent,
        RescheduleDialog,
        ICancelAppointmentDialog,
        IReportsComponent,
        ICalendarComponent,
        IOverallSummaryComponent,
        //pipes
        CapitalizePipe,
        FilterWorkshopsPipe,
        FilterAdvisorsPipe,
        ActiveServicesPipe,
        UsersComponent,
        ChangeStateUserDialog,
        FilterUserManagement,
        EditInfoUserDialog,
        CreateUserDialog,
        DeleteUserDialog,
        ClientsComponent,
        filterClientManagement,
        EditionClientsComponent,
        CreationClientsComponent,
        DeleteClientDialog,
        PopoverReschedulingComponent,
        AlertComponent,
        IPopoverReschedulingComponent,
        InformationModalComponent,
        NotFoundComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NgxChartsModule,
        CKEditorModule,
        FormsModule,
        ReactiveFormsModule,
        FullCalendarModule,
        NgbModule,
        MaterialModule,
        MatTabsModule,
        MatAutocompleteModule,
        MatInputModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        })], providers: [
        {
            // Set LOCALE_ID to Spanish
            provide: LOCALE_ID,
            useValue: 'en-US', //Set default to english
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // format all calendars to dd/MM/yyyy
        { provide: DateAdapter, useClass: LegacyDateAdapter },
        { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { formFieldAppearance: 'fill' } },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
